import { MediaManagerSDKFile } from '../../../../typings/media-manager-sdk';

export interface IFilesContext {
  files: MediaManagerSDKFile[];
  activeFile?: MediaManagerSDKFile;
  onFileAction: (params: IFilesAction) => void;
}

export interface IFilesAction {
  type: FilesStateActionType;
  payload: {
    files: MediaManagerSDKFile[];
  };
}

export enum FilesStateActionType {
  Prepend,
  Delete,
  SetActive,
}
